import isAligned from '../verifiers/is-aligned';
import isBlockElement from '../verifiers/is-block-element';
import isColoredElement from '../verifiers/is-colored-element';
import hasCustomFontSize from '../verifiers/has-custom-font-size';

const normalizeStyleAttribute = (element) => {
  if (isBlockElement(element) && hasCustomFontSize(element) && isAligned(element)) {
    const { textAlign } = element.style;
    const fontSizeVar = element.style.getPropertyValue('--font-size');
    const minFontSizeVar = element.style.getPropertyValue('--min-font-size');
    const lineHeightVar = element.style.getPropertyValue('--line-height');

    element.removeAttribute('style');

    element.style.textAlign = textAlign;
    element.style.setProperty('--font-size', fontSizeVar);
    element.style.setProperty('--min-font-size', minFontSizeVar);
    element.style.setProperty('--line-height', lineHeightVar);
    return;
  }

  if (hasCustomFontSize(element)) {
    const fontSizeVar = element.style.getPropertyValue('--font-size');
    const minFontSizeVar = element.style.getPropertyValue('--min-font-size');
    const lineHeightVar = element.style.getPropertyValue('--line-height');

    element.removeAttribute('style');

    element.style.setProperty('--font-size', fontSizeVar);
    element.style.setProperty('--min-font-size', minFontSizeVar);
    element.style.setProperty('--line-height', lineHeightVar);
    return;
  }

  if (isBlockElement(element) && isAligned(element)) {
    const { textAlign } = element.style;
    element.removeAttribute('style');
    element.style.textAlign = textAlign;
    return;
  }

  if (isColoredElement(element)) {
    const { color } = element.style;
    element.removeAttribute('style');
    element.style.color = color;
    return;
  }

  element.removeAttribute('style');
};

export default normalizeStyleAttribute;
